export default __webpack_public_path__ + "static/media/210613_me.76c65eab.png";